export async function overlayLogoOnImage(baseUrl, logoUrl) {
  const baseImage = await loadImage(baseUrl);
  const logo = await loadImage(logoUrl);

  const canvas = document.createElement("canvas");
  canvas.width = baseImage.width;
  canvas.height = baseImage.height;

  const ctx = canvas.getContext("2d");
  ctx.drawImage(baseImage, 0, 0);

  const scale = 0.105;
  const logoWidth = baseImage.width * scale;
  const logoHeight = (logo.height / logo.width) * logoWidth;

  let x = baseImage.width - logoWidth - 70;
  let y = baseImage.height - logoHeight - 60;

  ctx.drawImage(logo, x, y, logoWidth, logoHeight);

  return canvas.toDataURL("image/png");
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}
